function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function formattedTime(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
}

function capitalize(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}

async function fetchData(topic, params) {
    const queryString =
        params && Object.keys(params).length
            ? `?${new URLSearchParams(params).toString()}`
            : '';

    const url = `${this.$url}/${topic}${queryString}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + getCookie('token'),
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        let message = 'Request failed';

        try {
            const body = await response.json();
            message = body.error || body.message || message;
        } catch {
            message = await response.text();
        }

        const error = new Error(message);
        error.status = response.status;
        throw error;
    }

    return response.json();
}

module.exports = {
    getCookie,
    formattedTime,
    capitalize,
    fetchData
};